import { motion } from "framer-motion";

const STATS = [
  { value: "+6.000", label: "Alumnos entrenados" },
  { value: "+10.000", label: "Alumnos impactados" },
  { value: "+180h", label: "Horas de contenido" },
  { value: "+80", label: "Cursos y clases" },
  { value: "+18", label: "Países" },
  { value: "85%", label: "Win rate señales" },
];

export default function Stats() {
  return (
    <section className="relative py-20 md:py-28 bg-[#060806]" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#3E4D36]/30 rounded-2xl overflow-hidden border border-[#3E4D36]/40">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="bg-black py-10 px-6 text-center"
              data-testid={`stat-${s.label.toLowerCase().replace(/ /g, "-")}`}
            >
              <div className="font-display font-bold text-4xl md:text-5xl text-[#BEDD7D] tracking-tight">
                {s.value}
              </div>
              <div className="mt-2 text-[11px] md:text-xs uppercase tracking-[0.25em] text-white/50 font-display">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
